import styled, { css } from "styled-components";

interface MenuItemStyleProps {
  $active: boolean;
}

export const MenuTit = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    width: 18px;
    height: 18px;
  }
`;

export const MenuItem = styled.li<MenuItemStyleProps>`
  position: relative;
  display: flex;
  width: 100%;
  height: 48px;
  padding: 0 10px 0 14px;
  color: ${(props) => props.theme.colors.black80};
  font-size: 1.5rem;
  border-radius: 6px;
  align-items: center;
  justify-content: space-between;
  transition: all 0.2s ease;
  cursor: pointer;

  svg {
    path {
      fill: ${(props) => props.theme.colors.black30};
    }
  }

  &:hover {
    color: ${(props) => props.theme.colors.defaultHover};
    background: ${(props) => props.theme.colors.black2};

    svg {
      path {
        fill: ${(props) => props.theme.colors.defaultHover};
      }
    }
  }

  &::before {
    position: absolute;
    content: "";
    width: 4px;
    height: 30px;
    left: 0px;
    border-radius: 0 10px 10px 0;
  }

  ${(props) =>
    props.$active === true &&
    css`
      color: ${props.theme.colors.default};
      background: ${props.theme.colors.primary6};
      font-weight: 700;
      cursor: default;

      &::before {
        background: ${(props) => props.theme.colors.default};
      }

      svg {
        path {
          fill: ${(props) => props.theme.colors.default};
        }
      }

      &:hover {
        color: ${props.theme.colors.default};
        background: ${props.theme.colors.primary6};
        font-weight: 700;
        cursor: default;
      }
    `}
`;
